import { render, staticRenderFns } from "./order-push.vue?vue&type=template&id=62b149e2&scoped=true"
import script from "./order-push.vue?vue&type=script&lang=js"
export * from "./order-push.vue?vue&type=script&lang=js"
import style0 from "./order-push.vue?vue&type=style&index=0&id=62b149e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b149e2",
  null
  
)

export default component.exports